import React from "react";
import useAuthStudent from "../hooks/useAuthStudent";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PrivateRoutes({ children }) {
  const isLoggedIn = useAuthStudent();
  const auth = useSelector((state) => state.auth);
  const { user } = auth;

  return isLoggedIn ? children : <Navigate to="/" />;
}
